/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// 他のおすすめの箇所
	const courseSlider = () => {
		const courseSlide = document.querySelectorAll('.js-course-timeline');
		courseSlide.forEach((slide) => {
			// スライダーの対象要素を取得
			if (!slide) return; // 要素がなければ何もしない

			// Splideを一度だけ初期化
			const splide = new Splide(slide, {
				// この設定はモバイル（最小幅）のデフォルトとして機能します
				perPage: 1,
				gap: '16px',
				arrows: false,
				paginationKeyboard: true,
				autoplay: false,
				speed: 500,
				mediaQuery: 'min',
				// 画面幅に応じた設定の変更
				breakpoints: {
					// 画面幅が 1026px 以上の場合にスライダーを破棄（無効化）する
					1026: {
						destroy: true,
					}
				}
			});

			// Splideを実行
			splide.mount();

			const prevButton = slide.querySelector('.splide-arrow-prev');
			const nextButton = slide.querySelector('.splide-arrow-next');

			if (prevButton && nextButton) {
				prevButton.addEventListener('click', () => {
					// '前へ' ボタンがクリックされたら、前のスライドへ移動
					splide.go('<');
				});

				nextButton.addEventListener('click', () => {
					// '次へ' ボタンがクリックされたら、次のスライドへ移動
					splide.go('>');
				});
			}
		});
	}

	// モニターブロック開閉
	const monitorToggle = () => {
		const monitorBtn = document.querySelectorAll('.js-monitor-btn');

		if(!monitorBtn) return;

		monitorBtn.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				const parent = e.currentTarget.closest('.case-monitor');
				if(!parent) return;
				
				const monitorBlock = parent.querySelector('.js-monitor-block');
				if(monitorBlock) {

					if (btn.classList.contains(a)) {
						btn.classList.remove(a);
						btn.querySelector('span').textContent = '閉じる';
						monitorBlock.style.height = monitorBlock.scrollHeight + 'px';
					} else {
						btn.classList.add(a);
						btn.querySelector('span').textContent = '開く';
						monitorBlock.style.height = '0';
						// スクロール移動の追加
						const caseClass = btn.className.match(/case\d+/)?.[0];
						if (caseClass) {
							const targetElement = document.querySelector(`.${caseClass}`);
							if (targetElement) {
								setTimeout(() => {
									const headerOffset = window.innerWidth >= 1025 ? 112 : 74;
									const elementPosition = targetElement.getBoundingClientRect().top;
									const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
									
									window.scrollTo({
										top: offsetPosition,
										behavior: 'smooth'
									});
								}, 100);
							}
						}
					}
				}
			});
		});
	};

	

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		courseSlider();
		monitorToggle();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
